export interface RouteInfo {
    
    path?: string;
    title?: string;
    name?: string;
    icon?: string;
    class?: string;
    badge?: string;
    badgeClass?: string;
    is_external_link?: number; 
    is_divider?: number;
    submenu?: RouteInfo[];
    is_setting?: number;
    id?:string;
    parent_menu_id?:string;
    created_by_id?:string;
    created_date?:string;
    updated_by_id?:string;
    updated_date?:string;
    is_backup?:number;
    applications_id?:string;
    ordering?:number;
}
